import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import EditTemplate from './edittemplate/index'
import TemplateList from './templatelist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const EditTemplateProtected_ba = userIsBoardAdminRedir(EditTemplate)
const TemplateProtected_ba = userIsBoardAdminRedir(TemplateList)

const Template = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/template-list`} />
            <Route path={`${match.url}/edit-template/:id?`} component={EditTemplateProtected_ba} />
            <Route path={`${match.url}/template-list`} component={TemplateProtected_ba} />
        </Switch>
    </div>
);

export default Template;


// WEBPACK FOOTER //
// ./app/templatedetails/index.js